import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { CurrencyApi, CurrencyDataType } from "@/api/CurrencyApi";
import { showAlert } from "@utils/Alert";
import { CURRENCIES } from "@utils/Constants";
import { useAdminContext } from "@/hooks/useAdminContext";

const CurrenciesIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);
  const { adminTenantId, isAdminMode, profileBackUrl, adminQuerySuffix } = useAdminContext();

  useEffect(() => {
  }, []);

  const deleteRecord = async (id: string) => {
    try {
      await CurrencyApi.delete(id);
      showAlert('success', 'La moneda fue eliminado correctamente');
      modelRef.current?.refetch();
    } catch (err) {
      showAlert('danger', 'La moneda no puedo ser eliminado');
    }
  }

  const fetchData = (...args: any[]) =>
    isAdminMode ? CurrencyApi.fetchAllByOwnerId(adminTenantId!) : CurrencyApi.fetchAll(...args);

  return (
    <PageContainer
      title="Monedas"
      backUrl={profileBackUrl}
      primaryActions={[
        {
          onClick: () => {
            navigate(`/user/currency${adminQuerySuffix}`)
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<CurrencyDataType>
        ref={modelRef}
        fetchData={fetchData}
        filterProps={[
          {
            key: "codigo",
            filterType: "eq",
            type: "number"
          }
        ]}
        secondaryProperties={[
          {
            key: "currency_id",
            options: CURRENCIES,
            featured: true
          },
          {
            key: "exchange_rate",
            title: "Tipo Cambio",
            featuredTitle: true,
          },
          {
            key: "is_default",
            optionalHighlighted: (val: any) => { return val == "true" },
            highlightedText: "Predeterminada",
            nonHighlightedText: "No Predeterminada"
          }
        ]}
        listActions={[
          {
            href: `/user/currency/{:id}${adminQuerySuffix}`,
            actionTitle: "Editar Moneda",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Moneada",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Moneda",
              confirmMessage: "¿Seguro que desea eliminar esta cuenta Moneda?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default CurrenciesIndex;
